import { format, isValid } from 'date-fns';
import { FieldProps, getIn } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { DatePicker, IBaseInputProps } from '../../';

type IDatePickerFieldProps = IBaseInputProps & FieldProps;

export class DatePickerField extends React.PureComponent<IDatePickerFieldProps> {
    public render(): React.ReactElement {
        const {
            field,
            form: { errors, touched },
            ...props
        } = this.props;

        const error = getIn(errors, field.name);
        const isTouched = getIn(touched, field.name);
        const errorMessage: string | undefined = isTouched && typeof error === 'string' ? error : undefined;

        return (
            <DatePicker
                {...field}
                {...props}
                errorMessage={errorMessage}
                onDateSelected={this.handleChange}
                value={this.props.field.value}
            />
        );
    }

    private readonly handleChange = (value: Date | string | undefined): void => {
        const {
            field,
            form: { setFieldValue, setFieldTouched },
        } = this.props;
        // In case if we removed the field
        if (value === undefined) {
            setFieldValue(field.name, undefined);
            setFieldTouched(field.name, true, false);
            return;
        }
        // NB: date field values are always YYYY-MM-DD formatted strings
        if(value instanceof Date) {
            //value?.toISOString().split('T')[0];
            const dateOnly = format(value, 'yyyy-MM-dd');
            setFieldValue(field.name, dateOnly);
            setFieldTouched(field.name, true, false);
        }
    };
}
